import React from 'react';
import { AnchoredView } from '@shared/components/AnchoredSheet';
import { View } from '@shared/components/View';
import { ReactionPicker } from '../ReactionPicker';
import { MBReactionButton } from '../button';
import styles from './buttonWithPicker.module.css';
import { MBReactionButtonWithPickerProps } from './props';

interface State {
  showingPicker: boolean;
}

/*
    Combine a reaction button with a reaction picker when pressed.
*/
export class MBReactionButtonWithPicker extends React.PureComponent<
  MBReactionButtonWithPickerProps,
  State
> {
  state: State = { showingPicker: false };

  showPicker = () => {
    this.setState({ showingPicker: true });
  };

  hidePicker = () => {
    this.setState({ showingPicker: false });
  };

  render() {
    const { testID, selected, onToggleReaction, anchorName } = this.props;
    const { showingPicker } = this.state;
    return (
      <>
        <View style={{ anchorName }}>
          <MBReactionButton onPress={this.showPicker} testID={testID} />
        </View>
        {showingPicker && (
          <AnchoredView anchorName={anchorName} onClose={this.hidePicker} className={styles.picker}>
            <ReactionPicker
              selected={selected}
              onToggleReaction={(reactionType, add) => {
                this.hidePicker();
                onToggleReaction(reactionType, add);
              }}
              testID={testID ? `${testID}-picker` : undefined}
            />
          </AnchoredView>
        )}
      </>
    );
  }
}
